const SCORE_MAP: Record<number, number> = {
	1: 0.25,
	10: 0.25,
	2: 1,
	5: 1,
	3: 2,
	4: 2,
	6: 3,
	8: 3,
	7: 4,
	9: 4,
};

export const getBouncySumsQuestionScore = (firstNumber: number, secondNumber: number) => {
	return (SCORE_MAP[firstNumber] ?? 1) * (SCORE_MAP[secondNumber] ?? 1);
};
